module.exports = __webpack_public_path__ + "static/media/Jingwan Wang.2ef33fc3.jpg";